<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    animate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <content-loader width="1329" height="453" viewBox="0 0 1329 453" :speed="animate ? 2 : 0" primaryColor="#f8efe6" secondaryColor="#f8efe655">
    <rect x="29" y="26" width="398" height="51" rx="4" />
    <rect x="749" y="22" width="216" height="51" rx="4" />
    <rect x="975" y="22" width="128" height="54" rx="4" />
    <rect x="1114" y="22" width="128" height="54" rx="4" />
    <rect x="32" y="113" width="191" height="25" rx="4" />
    <rect x="32" y="148" width="191" height="25" rx="4" />
    <rect x="32" y="183" width="191" height="25" rx="4" />
    <rect x="32" y="218" width="191" height="25" rx="4" />
    <rect x="32" y="253" width="191" height="25" rx="4" />
    <rect x="48" y="321" width="151" height="83" rx="4" />
    <rect x="366" y="322" width="151" height="83" rx="4" />
    <rect x="684" y="323" width="151" height="83" rx="4" />
    <rect x="1002" y="324" width="151" height="83" rx="4" />
    <rect x="47" y="414" width="152" height="20" rx="4" />
    <rect x="365" y="415" width="152" height="20" rx="4" />
    <rect x="683" y="416" width="152" height="20" rx="4" />
    <rect x="1001" y="417" width="152" height="20" rx="4" />
    <rect x="335" y="107" width="33" height="34" rx="4" />
    <rect x="475" y="107" width="33" height="34" rx="4" />
    <rect x="615" y="107" width="33" height="34" rx="4" />
    <rect x="755" y="107" width="33" height="34" rx="4" />
    <rect x="895" y="107" width="33" height="34" rx="4" />
    <rect x="1035" y="107" width="33" height="34" rx="4" />
    <rect x="335" y="143" width="33" height="34" rx="4" />
    <rect x="475" y="143" width="33" height="34" rx="4" />
    <rect x="615" y="143" width="33" height="34" rx="4" />
    <rect x="755" y="143" width="33" height="34" rx="4" />
    <rect x="895" y="143" width="33" height="34" rx="4" />
    <rect x="1035" y="143" width="33" height="34" rx="4" />
    <rect x="335" y="178" width="33" height="34" rx="4" />
    <rect x="475" y="178" width="33" height="34" rx="4" />
    <rect x="615" y="178" width="33" height="34" rx="4" />
    <rect x="755" y="178" width="33" height="34" rx="4" />
    <rect x="895" y="178" width="33" height="34" rx="4" />
    <rect x="1035" y="178" width="33" height="34" rx="4" />
    <rect x="335" y="213" width="33" height="34" rx="4" />
    <rect x="475" y="213" width="33" height="34" rx="4" />
    <rect x="615" y="213" width="33" height="34" rx="4" />
    <rect x="755" y="213" width="33" height="34" rx="4" />
    <rect x="895" y="213" width="33" height="34" rx="4" />
    <rect x="1035" y="213" width="33" height="34" rx="4" />
    <rect x="335" y="248" width="33" height="34" rx="4" />
    <rect x="475" y="248" width="33" height="34" rx="4" />
    <rect x="615" y="248" width="33" height="34" rx="4" />
    <rect x="755" y="248" width="33" height="34" rx="4" />
    <rect x="895" y="248" width="33" height="34" rx="4" />
    <rect x="1035" y="248" width="33" height="34" rx="4" />
    <rect x="265" y="107" width="33" height="34" rx="4" />
    <rect x="405" y="107" width="33" height="34" rx="4" />
    <rect x="545" y="107" width="33" height="34" rx="4" />
    <rect x="685" y="107" width="33" height="34" rx="4" />
    <rect x="825" y="107" width="33" height="34" rx="4" />
    <rect x="965" y="107" width="33" height="34" rx="4" />
    <rect x="1105" y="107" width="33" height="34" rx="4" />
    <rect x="1175" y="107" width="33" height="34" rx="4" />
    <rect x="265" y="143" width="33" height="34" rx="4" />
    <rect x="405" y="143" width="33" height="34" rx="4" />
    <rect x="545" y="143" width="33" height="34" rx="4" />
    <rect x="685" y="143" width="33" height="34" rx="4" />
    <rect x="825" y="143" width="33" height="34" rx="4" />
    <rect x="965" y="143" width="33" height="34" rx="4" />
    <rect x="1105" y="143" width="33" height="34" rx="4" />
    <rect x="1175" y="143" width="33" height="34" rx="4" />
    <rect x="265" y="178" width="33" height="34" rx="4" />
    <rect x="405" y="178" width="33" height="34" rx="4" />
    <rect x="545" y="178" width="33" height="34" rx="4" />
    <rect x="685" y="178" width="33" height="34" rx="4" />
    <rect x="825" y="178" width="33" height="34" rx="4" />
    <rect x="965" y="178" width="33" height="34" rx="4" />
    <rect x="1105" y="178" width="33" height="34" rx="4" />
    <rect x="1175" y="178" width="33" height="34" rx="4" />
    <rect x="265" y="213" width="33" height="34" rx="4" />
    <rect x="405" y="213" width="33" height="34" rx="4" />
    <rect x="545" y="213" width="33" height="34" rx="4" />
    <rect x="685" y="213" width="33" height="34" rx="4" />
    <rect x="825" y="213" width="33" height="34" rx="4" />
    <rect x="965" y="213" width="33" height="34" rx="4" />
    <rect x="1105" y="213" width="33" height="34" rx="4" />
    <rect x="1175" y="213" width="33" height="34" rx="4" />
    <rect x="265" y="248" width="33" height="34" rx="4" />
    <rect x="405" y="248" width="33" height="34" rx="4" />
    <rect x="545" y="248" width="33" height="34" rx="4" />
    <rect x="685" y="248" width="33" height="34" rx="4" />
    <rect x="825" y="248" width="33" height="34" rx="4" />
    <rect x="965" y="248" width="33" height="34" rx="4" />
    <rect x="1105" y="248" width="33" height="34" rx="4" />
    <rect x="1175" y="248" width="33" height="34" rx="4" />
    <rect x="300" y="107" width="33" height="34" rx="4" />
    <rect x="440" y="107" width="33" height="34" rx="4" />
    <rect x="580" y="107" width="33" height="34" rx="4" />
    <rect x="720" y="107" width="33" height="34" rx="4" />
    <rect x="860" y="107" width="33" height="34" rx="4" />
    <rect x="1000" y="107" width="33" height="34" rx="4" />
    <rect x="1140" y="107" width="33" height="34" rx="4" />
    <rect x="1210" y="107" width="33" height="34" rx="4" />
    <rect x="300" y="143" width="33" height="34" rx="4" />
    <rect x="440" y="143" width="33" height="34" rx="4" />
    <rect x="580" y="143" width="33" height="34" rx="4" />
    <rect x="720" y="143" width="33" height="34" rx="4" />
    <rect x="860" y="143" width="33" height="34" rx="4" />
    <rect x="1000" y="143" width="33" height="34" rx="4" />
    <rect x="1140" y="143" width="33" height="34" rx="4" />
    <rect x="1210" y="143" width="33" height="34" rx="4" />
    <rect x="300" y="178" width="33" height="34" rx="4" />
    <rect x="440" y="178" width="33" height="34" rx="4" />
    <rect x="580" y="178" width="33" height="34" rx="4" />
    <rect x="720" y="178" width="33" height="34" rx="4" />
    <rect x="860" y="178" width="33" height="34" rx="4" />
    <rect x="1000" y="178" width="33" height="34" rx="4" />
    <rect x="1140" y="178" width="33" height="34" rx="4" />
    <rect x="1210" y="178" width="33" height="34" rx="4" />
    <rect x="300" y="213" width="33" height="34" rx="4" />
    <rect x="440" y="213" width="33" height="34" rx="4" />
    <rect x="580" y="213" width="33" height="34" rx="4" />
    <rect x="720" y="213" width="33" height="34" rx="4" />
    <rect x="860" y="213" width="33" height="34" rx="4" />
    <rect x="1000" y="213" width="33" height="34" rx="4" />
    <rect x="1140" y="213" width="33" height="34" rx="4" />
    <rect x="1210" y="213" width="33" height="34" rx="4" />
    <rect x="300" y="248" width="33" height="34" rx="4" />
    <rect x="440" y="248" width="33" height="34" rx="4" />
    <rect x="580" y="248" width="33" height="34" rx="4" />
    <rect x="720" y="248" width="33" height="34" rx="4" />
    <rect x="860" y="248" width="33" height="34" rx="4" />
    <rect x="1000" y="248" width="33" height="34" rx="4" />
    <rect x="1140" y="248" width="33" height="34" rx="4" />
    <rect x="1210" y="248" width="33" height="34" rx="4" />
  </content-loader>
</template>
